"use client";

import type { PropsWithChildren } from "react";
import { LandingDemoPreloader } from "./landing-demo-preloader";

export function LandingHomeShell({ children }: PropsWithChildren) {
	return <LandingDemoPreloader>{children}</LandingDemoPreloader>;
}
